import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { addDays, addYears } from "../../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { datePickerOptions } from "../../Resource/Contents";
import { Frequency } from "../../../../../../../Wrap/Constants/Enums/Domain/Frequency";

interface IIncomeReviewProps extends IProcessComponentProps {}

interface IIncomeReviewState {
    showPopUp: boolean;
}

export class IncomeReview extends ProcessComponent<IIncomeReviewProps, IIncomeReviewState> {
    constructor(props: any) {
        super(props);
        this.state = { showPopUp: false };
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.data.IncomeReviewDate == null) {
            this.props.onChange({ IncomeReviewDate: addYears(new Date(), 1) });
        }
        if (this.props.data.IncomeReviewFrequency == null) {
            this.props.onChange({ IncomeReviewFrequency: Frequency.Monthly });
        }
        if (this.props.data.IncomeReviewFrequencyCount == null) {
            this.props.onChange({ IncomeReviewFrequencyCount: 12 });
        }
    }

    private renderIncomeReviewDateWarningMessage() {
        const { showPopUp } = this.state;
        if (showPopUp) {
            return (
                <Lightbox
                    show={showPopUp}
                    title={"Warning"}
                    contentAfterTitle={null}
                    onClose={() => this.setState({ showPopUp: false })}
                    type={LightboxType.Modal}
                    cssWrapper="is-default-lightbox is-narrow"
                >
                    <p>Income review date is more than 3 years in the future. Please confirm this is correct</p>
                    <button className="btn primary" onClick={() => this.setState({ showPopUp: false })}>
                        OK
                    </button>
                </Lightbox>
            );
        }
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                <DatePicker
                    formGroupCssWrapper="control-size-245"
                    label={"Income review date"}
                    selected={JsonDateParser.toDateNoOffset(data?.DrawdownIncomeReviewDetails?.IncomeReviewDate)}
                    atLeast={{
                        value: addDays(new Date(), 20),
                        errorMessage: "Date must be 20 days or more in the future",
                    }}
                    onChange={(d) => {
                        if (d > addYears(new Date(), 3)) {
                            this.setState({ showPopUp: true });
                        }

                        this.onDataChange(onChange, { IncomeReviewDate: JsonDateParser.toJsonDateNoOffset(d) }, data, "DrawdownIncomeReviewDetails");
                    }}
                    filterDate={{
                        validator: (date: Date) => {
                            const dayOfWeek = date.getDay();
                            return dayOfWeek !== 0 && dayOfWeek !== 6;
                        },
                        errorMessage: "Please select a weekday",
                    }}
                    required={"Please enter next income review date "}
                    {...datePickerOptions}
                />
                {this.renderIncomeReviewDateWarningMessage()}

                <div className="row ml-0">
                    <NumberTextBoxEditor
                        cssWrapper="control-size-245"
                        label="Frequency of income review"
                        validationRules={[
                            {
                                errorMessage: "Frequency must be between 1 and 60",
                                validator: (v) => {
                                    return v >= 1 && v <= 60;
                                },
                            },
                        ]}
                        maxLength={2}
                        value={data?.DrawdownIncomeReviewDetails?.IncomeReviewFrequencyCount}
                        onChange={(v) => {
                            this.onDataChange(onChange, { IncomeReviewFrequency: Frequency.Monthly, IncomeReviewFrequencyCount: v }, data, "DrawdownIncomeReviewDetails");
                        }}
                        required={"Please enter frequency"}
                    />
                    <div className="mt-40 mb-0 ml-20">
                        <p>Months</p>
                    </div>
                </div>
            </>
        );
    }
}
